import { useState, useEffect } from 'react';
import { api } from '../api';

const BADGE = {
  validada:    { background: '#e8f5e9', color: '#2e7d32', label: '✅ Validada' },
  no_validada: { background: '#fce4ec', color: '#c62828', label: '❌ No validada' },
  pendiente:   { background: '#fff8e1', color: '#f57f17', label: '⏳ Pendiente' },
};

export default function Ordenes() {
  const [termino, setTermino] = useState('');
  const [ordenes, setOrdenes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [validando, setValidando] = useState(false);

  useEffect(() => {
    validarPendientes().then(() => buscar());
  }, []);

  const buscar = async (q = '') => {
    setCargando(true);
    try {
      const url = q ? `/ordenes/buscar?q=${encodeURIComponent(q)}` : '/ordenes/buscar';
      const data = await api.get(url);
      setOrdenes(data.ordenes || []);
    } catch (e) {
      console.error(e);
    } finally {
      setCargando(false);
    }
  };

  const validarPendientes = async () => {
    try {
      await api.post('/ordenes/validar', {});
    } catch (e) {
      console.log('Error validando:', e);
    }
  };

  const validarManual = async (id) => {
    setValidando(id);
    try {
      await api.post(`/ordenes/validar/${id}`, {});
      buscar(termino);
    } catch (e) {
      console.error(e);
    } finally {
      setValidando(null);
    }
  };

  const calcularRecorrido = (kmAnterior, kmActual) => {
    if (!kmAnterior || !kmActual) return null;
    const anterior = parseInt(kmAnterior.replace(/[^0-9]/g, ''));
    const actual = parseInt(kmActual.replace(/[^0-9]/g, ''));
    if (isNaN(anterior) || isNaN(actual)) return null;
    const recorrido = actual - anterior;
    return recorrido > 0 ? recorrido : null;
  };

  const generarHTML = (o) => {
    const recorrido = calcularRecorrido(o.km_anterior, o.km_actual);
    return `
    <html><head><meta charset="UTF-8">
    <style>
      * { box-sizing:border-box; margin:0; padding:0; }
      body { font-family:Arial,sans-serif; padding:14px; width:148mm; font-size:12px; }
      .header { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:10px; }
      .logo { font-size:18px; font-weight:bold; color:#1a1a2e; }
      .logo span { color:#e63946; }
      .orden-box { border:2px solid #1a1a2e; padding:6px 12px; text-align:center; border-radius:4px; }
      .orden-num { font-size:20px; font-weight:bold; color:#1a1a2e; }
      .datos { border:1px solid #ddd; border-radius:4px; padding:8px; margin-bottom:10px; }
      .datos table { width:100%; border-collapse:collapse; }
      .datos td { padding:3px 4px; font-size:11px; }
      .label { font-weight:bold; color:#555; width:30%; }
      .nota { background:#fff3cd; border:1px solid #ffc107; border-radius:4px; padding:6px 10px; margin-bottom:10px; font-size:11px; color:#856404; }
      .nota-km { background:#f0f4ff; border:1px solid #1a1a2e; border-radius:4px; padding:6px 10px; margin-bottom:10px; font-size:11px; color:#1a1a2e; }
      .firmas { display:flex; justify-content:space-between; margin-top:24px; }
      .firma { text-align:center; width:45%; }
      .firma-linea { border-top:1px solid #000; margin-bottom:4px; }
      .firma-txt { font-size:10px; color:#555; }
    </style></head>
    <body>
      <div class="header">
        <div>
          <div class="logo">🔧 TALLER <span>ZOLER</span></div>
          <div style="font-size:10px;color:#888;">LEON FONFAY LUBRICANTES</div>
        </div>
        <div class="orden-box">
          <div style="font-size:9px;font-weight:bold;color:#555;">ORDEN DE PEDIDO</div>
          <div class="orden-num">${o.numero_orden}</div>
        </div>
      </div>
      <div class="nota">🖨️ REIMPRESIÓN — Orden generada el ${o.fecha}</div>
      <div class="datos">
        <table>
          <tr>
            <td class="label">Cliente:</td><td>${o.cliente}</td>
            <td class="label">Placa:</td><td><strong>${o.placa}</strong></td>
          </tr>
          <tr>
            <td class="label">Teléfono:</td><td colspan="3">${o.telefono}</td>
          </tr>
          ${o.km_actual ? `<tr><td class="label">KM Actual:</td><td>${o.km_actual}</td><td class="label">KM Anterior:</td><td>${o.km_anterior}</td></tr>` : ''}
          ${o.tipo_vehiculo ? `<tr><td class="label">Tipo:</td><td>${o.tipo_vehiculo}</td><td class="label"></td><td></td></tr>` : ''}
          ${o.tecnico ? `<tr><td class="label">Técnico:</td><td colspan="3"><strong>${o.tecnico}</strong></td></tr>` : ''}
        </table>
      </div>
      ${recorrido ? `
      <div class="nota-km">
        📍 Kilómetros recorridos desde el último cambio: <strong>${recorrido.toLocaleString()} km</strong>
        (Kilometraje anterior: ${o.km_anterior})
      </div>` : ''}
      <table style="width:100%;border-collapse:collapse;margin-bottom:12px;">
        <thead>
          <tr style="background:#1a1a2e;color:#fff;">
            <th style="padding:6px 8px;font-size:11px;text-align:center;width:12%;">CANT.</th>
            <th style="padding:6px 8px;font-size:11px;text-align:left;">CÓDIGO</th>
            <th style="padding:6px 8px;font-size:11px;text-align:left;">DESCRIPCIÓN</th>
            <th style="padding:6px 8px;font-size:11px;text-align:center;width:12%;">UNID.</th>
          </tr>
        </thead>
        <tbody>
          ${o.items && o.items.length > 0
            ? o.items.map(item => `
              <tr>
                <td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;text-align:center;">${parseFloat(item.cantidad).toFixed(2)}</td>
                <td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;">${item.codigo}</td>
                <td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;">${item.descripcion}</td>
                <td style="padding:5px 8px;border:1px solid #ccc;font-size:11px;text-align:center;">${item.unidad}</td>
              </tr>`).join('')
            : '<tr><td colspan="4" style="text-align:center;padding:12px;color:#aaa;border:1px solid #ccc;">Sin ítems registrados</td></tr>'
          }
        </tbody>
      </table>
      <div class="firmas">
        <div class="firma"><div class="firma-linea"></div><div class="firma-txt">FIRMA AUTORIZADA</div></div>
        <div class="firma"><div class="firma-linea"></div><div class="firma-txt">TÉCNICO RESPONSABLE${o.tecnico ? `: ${o.tecnico}` : ''}</div></div>
      </div>
    </body></html>`;
  };

  const reimprimir = (orden) => {
    const ventana = window.open('', '_blank', 'width=800,height=600');
    if (!ventana) {
      alert('Permite las ventanas emergentes para este sitio');
      return;
    }
    ventana.document.write(generarHTML(orden));
    ventana.document.close();
    ventana.onload = () => {
      ventana.focus();
      ventana.print();
    };
  };

  return (
    <div>
      <h2 style={s.titulo}>📋 Órdenes</h2>

      <div style={s.buscadorRow}>
        <input
          style={s.input}
          value={termino}
          onChange={e => setTermino(e.target.value)}
          placeholder="Buscar por número o placa..."
          onKeyDown={e => e.key === 'Enter' && buscar(termino)}
        />
        <button style={s.botonBuscar} onClick={() => buscar(termino)}>🔍 Buscar</button>
        {termino && (
          <button style={s.botonLimpiar} onClick={() => { setTermino(''); buscar(''); }}>✕</button>
        )}
      </div>

      {cargando ? (
        <p style={s.cargando}>Cargando órdenes...</p>
      ) : ordenes.length === 0 ? (
        <p style={s.vacio}>No se encontraron órdenes</p>
      ) : (
        <div style={s.tabla}>
          <div style={s.tablaHeader}>
            <span style={{...s.col, flex: 1}}>Orden</span>
            <span style={{...s.col, flex: 1}}>Placa</span>
            <span style={{...s.col, flex: 2}}>Cliente</span>
            <span style={{...s.col, flex: 1}}>Técnico</span>
            <span style={{...s.col, flex: 1}}>Tipo</span>
            <span style={{...s.col, flex: 1}}>Fecha</span>
            <span style={{...s.col, flex: 1}}>Estado</span>
            <span style={{...s.col, width: 80}}>Acción</span>
          </div>

          {ordenes.map(o => {
            const badge = BADGE[o.validacion] || BADGE.pendiente;
            return (
              <div key={o.numero_orden} style={s.tablaRow}>
                <span style={{...s.col, flex: 1, color: '#4cc9f0', fontWeight: 'bold'}}>#{o.numero_orden}</span>
                <span style={{...s.col, flex: 1, color: '#fff', fontWeight: '600'}}>{o.placa}</span>
                <span style={{...s.col, flex: 2, color: '#ccc'}}>
                  {o.cliente}
                  {o.es_cliente_nuevo && <span style={s.badgeNuevo}>NUEVO</span>}
                </span>
                <span style={{...s.col, flex: 1, color: '#aaa'}}>{o.tecnico || '—'}</span>
                <span style={{...s.col, flex: 1, color: '#aaa'}}>{o.tipo_vehiculo || '—'}</span>
                <span style={{...s.col, flex: 1, color: '#aaa', fontSize: 12}}>{o.fecha}</span>
                <span style={{...s.col, flex: 1}}>
                  <span style={{...s.badge, background: badge.background, color: badge.color}}>
                    {badge.label}
                  </span>
                </span>
                <span style={{...s.col, width: 80, gap: 6}}>
                  <button style={s.botonImprimir} onClick={() => reimprimir(o)} title="Reimprimir">
                    🖨️
                  </button>
                  {o.validacion === 'no_validada' && (
                    <button
                      style={s.botonRevalidar}
                      onClick={() => validarManual(o.id)}
                      disabled={validando === o.id}
                      title="Revalidar"
                    >
                      {validando === o.id ? '...' : '🔄'}
                    </button>
                  )}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const s = {
  titulo: { color: '#fff', marginBottom: 24 },
  buscadorRow: { display: 'flex', gap: 8, marginBottom: 24 },
  input: { flex: 1, background: '#1e1e2e', border: '1px solid #2d2d44', borderRadius: 8, padding: '10px 16px', color: '#fff', fontSize: 14 },
  botonBuscar: { background: '#1a1a2e', border: '1px solid #4cc9f0', borderRadius: 8, color: '#4cc9f0', padding: '10px 20px', cursor: 'pointer', fontWeight: 'bold' },
  botonLimpiar: { background: '#2d2d44', border: 'none', borderRadius: 8, color: '#fff', padding: '10px 14px', cursor: 'pointer' },
  cargando: { color: '#aaa' },
  vacio: { color: '#555', textAlign: 'center', marginTop: 60 },
  tabla: { background: '#1e1e2e', borderRadius: 12, overflow: 'hidden' },
  tablaHeader: { display: 'flex', padding: '12px 16px', borderBottom: '1px solid #2d2d44', gap: 8 },
  col: { color: '#888', fontSize: 12, fontWeight: 'bold', display: 'flex', alignItems: 'center' },
  tablaRow: { display: 'flex', padding: '14px 16px', borderBottom: '1px solid #1a1a2e', gap: 8, alignItems: 'center' },
  badge: { fontSize: 11, fontWeight: '600', padding: '3px 8px', borderRadius: 4 },
  badgeNuevo: { background: '#e63946', color: '#fff', fontSize: 9, fontWeight: 'bold', padding: '2px 6px', borderRadius: 4, marginLeft: 6 },
  botonRevalidar: { background: 'none', border: '1px solid #555', borderRadius: 6, cursor: 'pointer', padding: '4px 8px', fontSize: 14 },
  botonImprimir: { background: '#1a1a2e', border: '1px solid #4cc9f0', borderRadius: 6, cursor: 'pointer', padding: '4px 8px', fontSize: 14, color: '#4cc9f0' },
};
